import { parseVerseReferenceFromSearchQuery } from './parseVerseReferenceQuery';

function escapeHtmlAttr(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;');
}

function stripHtmlTags(s) {
  return String(s || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Внутренний путь /перевод/bookId/chapter[/verse] из href в разметке ответа. */
export function extractHrefFromReferenceRow(row) {
  const s = String(row || '').trim();
  const m = s.match(/<a\b[^>]*\bhref=["']([^"']+)["']/i);
  if (!m) return null;
  const href = m[1].trim();
  if (/^\/[a-z0-9_-]+\/\d+\/\d+(?:\/\d+)?$/i.test(href)) return href;
  if (/^https?:\/\//i.test(href)) {
    try {
      const u = new URL(href);
      const local = u.pathname.match(/^\/([a-z0-9_-]+)\/(\d+)\/(\d+)(?:\/(\d+))?$/i);
      if (local) {
        return `/${local[1]}/${local[2]}/${local[3]}${local[4] ? `/${local[4]}` : ''}`;
      }
    } catch {
      /* not a URL */
    }
  }
  return null;
}

export function resolveReferenceHref(row, translation, books) {
  const fromAnchor = extractHrefFromReferenceRow(row);
  if (fromAnchor) return fromAnchor;

  let plain = stripHtmlTags(row).replace(/📖\s*/gi, '').trim();
  const dashAt = plain.search(/\s+[-–—]\s+/);
  if (dashAt > 0) plain = plain.slice(0, dashAt).trim();

  const parsed = parseVerseReferenceFromSearchQuery(plain, books, translation);
  if (!parsed?.bookId || !parsed?.chapter) return null;

  const tr = parsed.translation || translation;
  let path = `/${tr}/${parsed.bookId}/${parsed.chapter}`;
  if (parsed.verse) path += `/${parsed.verse}`;
  return path;
}

function refPartForDisplay(refPart) {
  const s = String(refPart || '').trim();
  const m = s.match(/<a\b[^>]*>([\s\S]*?)<\/a>/i);
  return m ? m[1].trim() : s;
}

/** Одна строка «Исая 1:17 — пояснение» → карточка; при href вся карточка — ссылка. */
export function formatReferenceLine(line, href) {
  const row = String(line || '')
    .replace(/📖\s*/gi, '')
    .trim();
  if (!row) return '';

  const dashAt = row.search(/\s+[-–—]\s+/);
  let refPart;
  let notePart = '';
  if (dashAt > 0) {
    refPart = row.slice(0, dashAt).trim();
    notePart = row.slice(dashAt).replace(/^\s*[-–—]\s+/, '').trim();
  } else {
    refPart = row;
  }
  refPart = refPartForDisplay(refPart);

  const inner = notePart
    ? `<div class="bf-chat-refs__ref">${refPart}</div><p class="bf-chat-refs__note">${notePart}</p>`
    : `<div class="bf-chat-refs__ref">${refPart}</div>`;

  if (href) {
    return `<a href="${escapeHtmlAttr(href)}" class="chat-refs-line bf-chat-refs__item bf-chat-refs__item--link">${inner}</a>`;
  }
  return `<div class="chat-refs-line bf-chat-refs__item">${inner}</div>`;
}
